import type { Agenda } from '../../types';

// Preliminary program. Individual session times haven't been published, so the
// Tuesday sessions are labelled by number until final timings are confirmed.
export const agenda: Agenda = [
  {
    date: 'Monday, December 7',
    items: [
      {
        id: 'day1-small-group-dinner',
        time: '7:30 PM - 9:00 PM',
        title: 'Optional Small Group Dinner',
        description:
          'Join a small group of LPs, members of our investment team, and CEOs from Fund I and Fund II portfolio companies for dinner and conversation. We anticipate both bioscience-focused and technology-focused discussions and will do our best to accommodate your preference. Please RSVP by October 31st; attendees and locations will be shared closer to the event.',
        locationId: 'dinner',
        type: 'meal',
        link: {
          label: 'RSVP for the small group dinner',
          url: 'https://www.surveymonkey.com/r/YXV566S',
        },
      },
    ],
  },
  {
    date: 'Tuesday, December 8',
    items: [
      {
        id: 'day2-session-1',
        time: 'Session 1',
        title: 'Firm Updates & Fund I & II Performance Overview',
        description: '',
        locationId: 'andaz',
        type: 'presentation',
      },
      {
        id: 'day2-session-2',
        time: 'Session 2',
        title: 'CEO Speaker Series',
        description:
          'Company updates and moderated LP Q&A, with a scheduled break. Featuring Montara Therapeutics, Talus Bio, LENS, Elisity, and Rainfall Health; speaking order will be confirmed in the coming weeks.',
        speakerIds: ['nh', 'lp', 'kp', 'jw', 'eq'],
        locationId: 'andaz',
        type: 'panel',
      },
      {
        id: 'day2-session-3',
        time: 'Session 3',
        title: 'AI: Implementations Across Our Portfolio',
        description: '',
        locationId: 'andaz',
        type: 'panel',
      },
      {
        id: 'day2-session-4',
        time: 'Session 4',
        title: 'Firm, Fund & Investment Outlook',
        description: '',
        locationId: 'andaz',
        type: 'presentation',
      },
      {
        id: 'day2-lp-dinner',
        time: '5:30 PM - 8:00 PM',
        title: 'Cocktails & LP Dinner',
        description: '',
        locationId: 'dinner',
        type: 'reception',
      },
    ],
  },
];
